import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-316">
        {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-317">
            {label}
          </label>}
        <div className="relative" data-id="element-318">
          {leftIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-319">
              {leftIcon}
            </div>}
          <input ref={ref} id={inputId} className={`
              w-full px-4 py-2.5 rounded-xl border bg-white
              text-slate-900 placeholder:text-slate-400
              transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent
              disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed
              ${leftIcon ? 'pl-10' : ''}
              ${rightIcon ? 'pr-10' : ''}
              ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-200 hover:border-slate-300'}
              ${className}
            `} {...props} data-id="element-320" />
          {rightIcon && <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-321">
              {rightIcon}
            </div>}
        </div>
        {error && <p className="mt-1.5 text-sm text-red-500" data-id="element-322">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-slate-500" data-id="element-323">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';